import { z } from "zod";
import { customErrorMap } from "../shared/validation/zod";
import { AccountAddSchema, AccountEditSchema, AccountSchema } from "./account";
import { DocumentAccountCustomDataFormSchema, DocumentAccountCustomDataSchema } from "./document-customer-custom-data";

z.setErrorMap(customErrorMap);

export const DocumentAccountSchema = AccountSchema.extend({

    id: z.number(),
    
    document_id: z.number(), // document object id.
    account_id: z.number(), // customer object id.

    custom_data: z.array(DocumentAccountCustomDataSchema).optional(),

});

export const DocumentAccountEditSchema = AccountEditSchema.extend({

    id: z.number(),

    document_id: z.number().optional(), // document object id.
    account_id: z.number(), // customer object id.

    custom_data: z.array(DocumentAccountCustomDataFormSchema).optional(),

});

export const DocumentAccountAddSchema = AccountAddSchema.extend({

    id: z.number().optional(),

    document_id: z.number().optional(), // document object id.
    account_id: z.number(), // customer object id.

    custom_data: z.array(DocumentAccountCustomDataFormSchema).optional(),

});

export type DocumentAccount = z.infer<typeof DocumentAccountSchema>
export type DocumentAccountEdit = z.infer<typeof DocumentAccountEditSchema>
export type DocumentAccountAdd = z.infer<typeof DocumentAccountAddSchema>